import React, {Component} from 'react';
import API from '../services/API';
import LogoPic from "../assets/images/trlogo.png";
import LogoGohar from "../assets/images/goharzaminLogo.png";

class Splash extends Component {
    render() {
        return (
           <section className="container ">
               <div className="row text-center">
                   <div className="col-12 pt-5">
                       {
                           window.localStorage.getItem("sysTitle") && window.localStorage.getItem("sysTitle").indexOf('زمین') < 0 ?
                               <img src={LogoPic} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " /> :
                               <img src={LogoGohar} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " width='200' />
                       }
                   </div>
                   <h2 className="col-12 text-center mt-4 header-text">
                       {window.localStorage.getItem("sysTitle")}
                   </h2>
                   <h6 className="col-12 text-center mt-4 text-secondary">
                      سامانه هوشمند حمل و نقل بین شهری
                   </h6>
                   <div className="col-12 text-center fixed-bottom mb-3">
                       <div className="spinner-grow header-text" role="status">

                       </div>
                   </div>
               </div>
           </section>
        );
    }
    componentDidMount = () => {

        API.start()
            .then((response) => {

                const userLogin = response.results.user_login;
                if(userLogin) {
                    window.localStorage.setItem("gid", response.results.user.user_groups_global[0].id);
                    window.localStorage.setItem("gv", response.results.user.user_groups_global[0].is_verified);
                }

                setTimeout(() => {
                    userLogin ? this.props.history.push("/home") : this.props.history.push("/login");
                }, 2000);
            })
    }
}

export default Splash;